import Vue from 'vue';
import Vuex from 'vuex';
import controller from './controllerStore.js'

Vue.use(Vuex);
//相当于data
const state = {
  // 检查医生
  me: "",
  doctorDitail: {},
  // 账户信息
  accountInfo: {},
  // 患者的id
  patientId: 0,
  // 患者在医院的身份编号
  idInHospital: 0,
  //拖拽的报告图片
  reportImgs: [],
  // 智能搜图所选择的图片数组
  chooseItImgArr: [],
  // 智能搜图所选择的图片数组
  chooseItImgArrDtt: [],
  // 智能搜图所选择的图片数组
  chooseItImgArrBc: [],
  // 智能搜图所选择的图片数组
  chooseItImgArrCt: [],
  // 智能搜图所选择的图片数组
  chooseItImgArrBl: [],
    // 智能搜图所选择的图片数组
    chooseItImgArrSkin: [],
  // 点击的相似图片
  similarImg: '',
  // 皮肤镜报告图片
  skinReportImgs: [],
  skinUnderMirror: "",
  generalReportImgs: [],
  generalUnderMirror: "",
  ctReportImgs: [],
  ctUnderMirror: "",
  bcReportImgs: [],
  bcUnderMirror: "",
  blReportImgs: [],
  blUnderMirror: "",
  filterState: {
    diagnoseSelect: {},
    diagnoseForm: {
      image_type_flag: '',
      position: '',
      doctor_conclusion: '',
      applicant: '',
      applicant_unit: '',
      review_doctor: '',
      unit: '',
      id_in_hospital: '',
      initial_conclusion: '',
      name: '',
      gender: '',
      age_start: '',
      age_end: '',
      skin_color: '',
      phone: '',
      address: '',
      time_start: '',
      time_end: '',
      tagged: '',
      id_card_number: '',
      native_place: '',
      country: '',
      profession: '',
      email: '',
      complaint: '',
      disease_history_before: '',
      disease_history_present: '',
      disease_history_family: '',
      lab: '',
      race: '',
    },
    data: {
      age_start: '',
      age_end: '',
      dateRange: '',
      position_overview: '',
      position_detail: '',
      imageTypeFilter: [],
      taggedFilter: '',
      imgDiagnose_main: '',
      imgDiagnose_sub: '',
    },
    saveState: false,
  },
  sss: '',
  // 从患者管理跳转到智能诊断的参数对象
  pToIntellParams: null,
  // 百科全书
  wordBook: {},
// 编辑的（保存）的照片src
  editImgSrc: "",
// 编辑照片的状态
  editStatus: false,
  editimgId: null,
// 标注色卡默认颜色
  clolrPickerDefault: "#FF0000",
  // secret
  secret: '',
  // 诊断详情页点击修改诊断的id
  modifyDiagnosisData: {
    isModify: false,
    patientinfo: {},
    diagnosisinfo: {},
    diagnosisId: -1,
  },
  // 从患者列表跳转到患者历史诊断详情页面所需参数
  patientDiagnosisRecordPara: {
    patientId: -1,
    selectId: -1,
    diagnosisType: ""
  },


  /////////////////////手术相关全局状态信息 ////////////////
  operationPatientId: null,// 手术中的患者id
  operationRelevantId: null,// 手术中相关信息id
  operationElectiveId: null,// 手术中预约id
  operationFormPatientStatus: false,//手术表单是否被清空
  operationFormRelevantStatus: false,
  operationFormElectiveStatus: false,
  operationClearClick: false,//手术预约清空按钮
  hasNewElective: false, //是否有新预约
  editOperation: false,// 是否为编辑手术预约状态
  editObjId: {operationId: '', relevantId: "", patinetsId: ""},// 编辑手术预约id集合
  operationPrintDiagnoses: '',
  operationPrintInHospitaiNum: "",
  operationInput:false,// 手术相关信息是否处于修改状态
  ///////////////////// 手术相关全局状态信息 END////////////////

  /////////////////////美容登记相关全局状态信息 ////////////////
  cosmetRegistrationPatientId: null,// 美容登记患者id
  cosmetRegistrationRelevantId: null,// 美容登记相关信息id
  cosmetRegistrationElectiveId: null,// 美容登记预约id
  cosmetRegistrationFormPatientStatus: false,//美容登记表单是否被清空
  cosmetRegistrationFormRelevantStatus: false,
  cosmetRegistrationFormElectiveStatus: false,
  cosmetRegistrationClearClick: false,//美容登记预约清空按钮
  // 新版本不在使用该变量进行列表更新，而是采用 this.$root.$emit("refreshCosmetRegistrationList");
  hasNewcosmetRegistrationElective: false, //是否有新预约
  editcosmetRegistration: false,// 是否为编辑美容登记预约状态
  editcosmetRegistrationObjId: {operationId: '', relevantId: "", patinetsId: ""},// 编辑美容登记预约id集合
  cosmetRegistrationPrintDiagnoses: '',
  cosmetRegistrationPrintInHospitaiNum: "",
  cosmetRegistrationInput:false,// 美容登记相关信息是否处于修改状态
  ///////////////////// 美容登记相关全局状态信息 END////////////////


  // 登录界面loading
  loginLoading: null,
  // 判断美容是否继续治疗的数据
  continueTreatData: {
    status: false,
    statusCount: 0,// 控制是否取消状态的一个数值
    patient_id: -1,
    total_times: 0,
    left_times: 0,
    parent_id: '',
  },
  modifyCosmetologyData: {
    status: false,
    statusCount: 0, // 控制是否取消状态的一个数值
    patient_id: -1,
    treat_no: '',
    current_times: 0,
    total_times: 0,
    parent_id: '',
  },
  cosmetologyData: {
    status: false,
    statusCount: 0, // 控制是否取消状态的一个数值
    patient_id: -1,
  },

}
const mutations = {

  /////////////////////设置手术相关全局状态信息 ////////////////
  setoperationInput(state, value) {
    state.operationInput = value
  },
  setoperationPrintInHospitaiNum(state, value) {
    state.operationPrintInHospitaiNum = value
  },
  setoperationPrintDiagnoses(state, value) {
    state.operationPrintDiagnoses = value
  },
  seteditObjId(state, value) {
    state.editObjId.operationId = value[0]
    state.editObjId.relevantId = value[1]
    state.editObjId.patinetsId = value[2]
  },
  seteditOperation(state, value) {
    state.editOperation = value
  },
  sethasNewElective(state, value) {
    state.hasNewElective = value
  },
  setoperationFormElectiveStatus(state, value) {
    state.operationFormElectiveStatus = value
  },
  setoperationFormRelevantStatus(state, value) {
    state.operationFormRelevantStatus = value
  },
  setoperationFormPatientStatus(state, value) {
    state.operationFormPatientStatus = value
  },
  setoperationClearClick(state, value) {
    state.operationClearClick = value
  },

  setoperationRelevantId(state, value) {
    state.operationRelevantId = value
  },
  setoperationElectiveId(state, value) {
    state.operationElectiveId = value
  },
  setoperationPatientId(state, value) {
    state.operationPatientId = value
  },
  /////////////////////设置手术相关全局状态信息 END ////////////////


  /////////////////////设置美容登记全局状态信息 ////////////////
  setcosmetRegistrationInput(state, value) {
    state.cosmetRegistrationInput = value
  },
  setcosmetRegistrationPrintInHospitaiNum(state, value) {
    state.cosmetRegistrationPrintInHospitaiNum = value
  },
  setcosmetRegistrationPrintDiagnoses(state, value) {
    state.cosmetRegistrationPrintDiagnoses = value
  },
  seteditcosmetRegistrationObjId(state, value) {
    state.editcosmetRegistrationObjId.operationId = value[0]
    state.editcosmetRegistrationObjId.relevantId = value[1]
    state.editcosmetRegistrationObjId.patinetsId = value[2]
  },
  seteditcosmetRegistration(state, value) {
    state.editcosmetRegistration = value
  },
  sethasNewcosmetRegistrationElective(state, value) {
    state.hasNewcosmetRegistrationElective = value
  },
  setcosmetRegistrationFormElectiveStatus(state, value) {
    state.cosmetRegistrationFormElectiveStatus = value
  },
  setcosmetRegistrationFormRelevantStatus(state, value) {
    state.cosmetRegistrationFormRelevantStatus = value
  },
  setcosmetRegistrationFormPatientStatus(state, value) {
    state.cosmetRegistrationFormPatientStatus = value
  },
  setcosmetRegistrationClearClick(state, value) {
    state.cosmetRegistrationClearClick = value
  },
  setcosmetRegistrationRelevantId(state, value) {
    state.cosmetRegistrationRelevantId = value
  },
  setcosmetRegistrationElectiveId(state, value) {
    state.cosmetRegistrationElectiveId = value
  },
  setcosmetRegistrationPatientId(state, value) {
    state.cosmetRegistrationPatientId = value
  },
  /////////////////////设置美容登记全局状态信息 END ////////////////
  
  // 设置账户信息(2026-04-19更新：增加账户信息的存储，包括套餐类型，日期，当前存储空间使用情况等)
  setAccountInfo(state, value) {
    state.accountInfo = value
  },

  setdoctorDitail(state, value) {
    state.doctorDitail = value
  },
  setClolrPickerDefault(state, value) {
    state.clolrPickerDefault = value;
  },
  setEditStatus(state, value) {
    state.editStatus = value;
  },
  setEditimgId(state, value) {
    state.editimgId = value;
  },
  setWordBook(state, value) {
    state.wordBook = value;
  },
  setPToIntell(state, value) {
    if (typeof (value) === "object")
      state.pToIntellParams = value;
  },
  clearPToIntell(state) {
    state.pToIntellParams = null;
  },
  add(state, ele) {
    state.reportImgs.push(ele);
  },
  setPatientId(state, value) {
    state.patientId = value;
  },
  setIdInHospital(state, value) {
    state.idInHospital = value;
  },
  clearchooseItImgArr(state) { // 清空智能搜图数据
    state.chooseItImgArr = [];
  },
  // clearchooseItImgArrDtt(state) { // 清空智能搜图数据
  //   state.chooseItImgArrDtt = [];
  // },
  // clearchooseItImgArrBl(state) { // 清空智能搜图数据
  //   state.chooseItImgArrBl = [];
  // },
  // clearchooseItImgArrBc(state) { // 清空智能搜图数据
  //   state.chooseItImgArrBc = [];
  // },
  // clearchooseItImgArrCt(state) { // 清空智能搜图数据
  //   state.chooseItImgArrCt = [];
  // },
  clearchooseItImgArrSkin(state) { // 清空智能搜图数据
    state.chooseItImgArrSkin = [];
  },
  pushItImgArr(state, item) {
    let canPush = true;
    for (let i = 0; i < state.chooseItImgArr.length; i++) {
      if (state.chooseItImgArr[i].id === item.id) {
        canPush = false;
      }
    }
    if (canPush) {
      state.chooseItImgArr.push(item);
    }
  },
  popItImgArr(state, item) {
    for (let i = 0, len = state.chooseItImgArr.length; i < len; i++) {
      if (state.chooseItImgArr[i].id === item.id) {
        state.chooseItImgArr.splice(i, 1);
        return;
      }
    }
  },
  pushItImgArrSkin(state, item) {
    let canPush = true;
    for (let i = 0; i < state.chooseItImgArrSkin.length; i++) {
      if (state.chooseItImgArrSkin[i].id === item.id) {
        canPush = false;
      }
    }
    if (canPush) {
      state.chooseItImgArrSkin.push(item);
    }
  },
  popItImgArSkin(state, item) {
    for (let i = 0, len = state.chooseItImgArrSkin.length; i < len; i++) {
      if (state.chooseItImgArrSkin[i].id === item.id) {
        state.chooseItImgArrSkin.splice(i, 1);
        return;
      }
    }
  },
  // pushItImgArrDtt(state, item) {
  //   let canPush = true;
  //   for (let i = 0; i < state.chooseItImgArrDtt.length; i++) {
  //     if (state.chooseItImgArrDtt[i].id === item.id) {
  //       canPush = false;
  //     }
  //   }
  //   if (canPush) {
  //     state.chooseItImgArrDtt.push(item);
  //   }
  // },
  // popItImgArrDtt(state, item) {
  //   for (let i = 0, len = state.chooseItImgArrDtt.length; i < len; i++) {
  //     if (state.chooseItImgArrDtt[i].id === item.id) {
  //       state.chooseItImgArrDtt.splice(i, 1);
  //       return;
  //     }
  //   }
  // },
  // pushItImgArrBl(state, item) {
  //   let canPush = true;
  //   for (let i = 0; i < state.chooseItImgArrBl.length; i++) {
  //     if (state.chooseItImgArrBl[i].id === item.id) {
  //       canPush = false;
  //     }
  //   }
  //   if (canPush) {
  //     state.chooseItImgArrBl.push(item);
  //   }
  // },
  // popItImgArrBl(state, item) {
  //   for (let i = 0, len = state.chooseItImgArrBl.length; i < len; i++) {
  //     if (state.chooseItImgArrBl[i].id === item.id) {
  //       state.chooseItImgArrBl.splice(i, 1);
  //       return;
  //     }
  //   }
  // },
  // pushItImgArrCt(state, item) {
  //   let canPush = true;
  //   for (let i = 0; i < state.chooseItImgArrCt.length; i++) {
  //     if (state.chooseItImgArrCt[i].id === item.id) {
  //       canPush = false;
  //     }
  //   }
  //   if (canPush) {
  //     state.chooseItImgArrCt.push(item);
  //   }
  // },
  // popItImgArrCt(state, item) {
  //   for (let i = 0, len = state.chooseItImgArrCt.length; i < len; i++) {
  //     if (state.chooseItImgArrCt[i].id === item.id) {
  //       state.chooseItImgArrCt.splice(i, 1);
  //       return;
  //     }
  //   }
  // },
  // pushItImgArrBc(state, item) {
  //   let canPush = true;
  //   for (let i = 0; i < state.chooseItImgArrBc.length; i++) {
  //     if (state.chooseItImgArrBc[i].id === item.id) {
  //       canPush = false;
  //     }
  //   }
  //   if (canPush) {
  //     state.chooseItImgArrBc.push(item);
  //   }
  // },
  // popItImgArrBc(state, item) {
  //   for (let i = 0, len = state.chooseItImgArrBc.length; i < len; i++) {
  //     if (state.chooseItImgArrBc[i].id === item.id) {
  //       state.chooseItImgArrBc.splice(i, 1);
  //       return;
  //     }
  //   }
  // },
  getItImgArr(state) {
    return state.chooseItImgArr;
  },
  setSimilarImg(state, value) {
    state.similarImg = value;
  },
  handleReportByType(state, value) {
    if (value.opration === 'add') {
      switch (value.type) {
        case "skin":
          state.skinReportImgs.push(value.data);
          break;
        case "general":
          state.generalReportImgs.push(value.data);
          break;
        case "ct":
          state.ctReportImgs.push(value.data);
          break;
        case "bc":
          state.bcReportImgs.push(value.data);
          break;
        case "bl":
          state.blReportImgs.push(value.data);
          break;
      }
    } else {
      switch (value.type) {
        case "skin":
          state.skinReportImgs.splice(value.index, 1);
          break;
        case "general":
          state.generalReportImgs.splice(value.index, 1);
          break;
        case "ct":
          state.ctReportImgs.splice(value.index, 1);
          break;
        case "bc":
          state.bcReportImgs.splice(value.index, 1);
          break;
        case "bl":
          state.blReportImgs.splice(value.index, 1);
          break;
      }
    }
  },
  handleUnderMirror(state, value) {
    switch (value.type) {
      case "skin":
        state.skinUnderMirror = value.data;
        break;
      case "general":
        state.generalUnderMirror = value.data;
        break;
      case "ct":
        state.ctUnderMirror = value.data;
        break;
      case "bc":
        state.bcUnderMirror = value.data;
        break;
      case "bl":
        state.blUnderMirror = value.data;
        break;
    }
  },
  saveFilterState(state, data) {
    state.filterState = data;
  },
  clearSaveState(state) {
    state.filterState.saveState = false;
  },
  setMe(state, value) {
    state.me = value;
  },
  clearHandleReportByType(state) {
    state.skinReportImgs = [];
    state.generalReportImgs = [];
    state.ctReportImgs = [];
    state.bcReportImgs = [];
    state.blReportImgs = [];
    state.blReportImgs = [];
  },
  setEditImgSrc(state, data) {
    state.editImgSrc = data;
  },
  secret(state, data) {
    state.secret = data;
  },
  // 添加编辑诊断和缓存诊断页面
  addModifyDiagnosis(state, {patientinfo, diagnosisinfo, diagnosisId}) {
    state.modifyDiagnosisData.isModify = true;
    // state.modifyDiagnosisData.patientinfo = patientinfo;
    // state.modifyDiagnosisData.diagnosisinfo = diagnosisinfo;
    state.modifyDiagnosisData.diagnosisId = diagnosisId;
  },
  clearModifyDiagnosisId(state) {
    state.modifyDiagnosisData.isModify = false;
    state.modifyDiagnosisData.patientinfo = {};
    state.modifyDiagnosisData.diagnosisinfo = {};
    state.modifyDiagnosisData.diagnosisId = -1;
  },
  openLoading(state, data) {
    state.loginLoading = data;
  },
  // 设置跳转到患者历史诊断详情页面的参数
  setPatientDiagnosisRecordPara(state, {patientId,selectId,diagnosisType}){
    state.patientDiagnosisRecordPara.patientId = patientId;
    state.patientDiagnosisRecordPara.selectId = selectId;
    state.patientDiagnosisRecordPara.diagnosisType = diagnosisType;
  },


  // 添加美容继续治疗的状态 传入参数
  addContinueTreat(state, {patient_id, left_times, total_times, treat_no,parent_id}) {
    state.continueTreatData.status = true;
    state.continueTreatData.patient_id = patient_id;
    state.continueTreatData.left_times = left_times;
    state.continueTreatData.total_times = total_times;
    state.continueTreatData.parent_id = parent_id;
    state.continueTreatData.treat_no = treat_no;
    console.log(left_times,total_times)
  },
  // 美容编辑状态计数加一
  addContinueTreatStatusCount(state) {
    state.continueTreatData.statusCount++;
  },
  // 清除美容继续治疗的状态
  clearContinueTreat(state) {
    state.continueTreatData.status = false;
    state.continueTreatData.statusCount = 0;
    state.continueTreatData.patient_id = -1;
    state.continueTreatData.left_times = 0;
    state.continueTreatData.total_times = 0;
    state.continueTreatData.parent_id = '';
    state.continueTreatData.treat_no = '';
  },
  // 添加美容编辑的状态 传入参数
  addModifyCosmetology(state, data) {
    state.modifyCosmetologyData.status = true;
    state.modifyCosmetologyData.patient_id = data.patient_id;
    state.modifyCosmetologyData.treat_no = data.treat_no;
    state.modifyCosmetologyData.current_times = data.current_times;
    state.modifyCosmetologyData.total_times = data.total_times;
    state.modifyCosmetologyData.parent_id = data.parent_id;
  },
  // 美容编辑状态计数加一
  addModifyCosmetologyStatusCount(state) {
    state.modifyCosmetologyData.statusCount++;
  },
  // 清除美容编辑的状态
  clearModifyCosmetology(state) {
    state.modifyCosmetologyData.status = false;
    state.modifyCosmetologyData.statusCount = 0;
    state.modifyCosmetologyData.patient_id = -1;
    state.modifyCosmetologyData.treat_no = '';
    state.modifyCosmetologyData.current_times = 0;
    state.modifyCosmetologyData.total_times = 0;
    state.modifyCosmetologyData.parent_id = '';
  },
  // 患者列表点击添加美容
  addCosmetology(state, data) {
    state.cosmetologyData.status = true;
    state.cosmetologyData.patient_id = data.patient_id;
  },
  // 美容状态计数加一
  addCosmetologyStatusCount(state) {
    state.cosmetologyData.statusCount++;
  },
  // 清除美容编辑的状态
  clearCosmetology(state) {
    state.cosmetologyData.status = false;
    state.cosmetologyData.statusCount = 0;
    state.cosmetologyData.patient_id = -1;
  },
  
}
const getters = {
  //清除手术状态信息
  getOperationClear(state) {
    return state.operationFormPatientStatus && state.operationFormRelevantStatus && state.operationFormElectiveStatus
  },
  //清除美容登记状态信息
  getcosmetRegistrationClear(state) {
    return state.cosmetRegistrationFormPatientStatus && state.cosmetRegistrationFormRelevantStatus && state.cosmetRegistrationFormElectiveStatus
  },

  getPToIntell(state) {
    return state.pToIntellParams;
  },
  getMe(state) {
    return state.me;
  },
  getReportImgs(state) {
    return state.reportImgs;
  },
  getItImgArr(state) {
    return state.chooseItImgArr;
  },
  getSimilarImg(state) {
    return state.similarImg;
  },
  getSkinUnderMirror(state) {
    return state.skinUnderMirror;
  },
  getGeneralUnderMirror(state) {
    return state.generalUnderMirror;
  },
  getCTUnderMirror(state) {
    return state.ctUnderMirror;
  },
  getBCUnderMirror(state) {
    return state.bcUnderMirror;
  },
  getBlUnderMirror(state) {
    return state.blUnderMirror;
  },
  getEditImgSrc(state) {
    return state.editImgSrc;
  }
}
const actions = {}
const modules={
  controller:controller
}

export default new Vuex.Store({
  state,
  modules,
  mutations,
  getters,
  actions
})
